import { createSelector } from '@reduxjs/toolkit'

import { selectBusinessPrioritiesState } from './selectBusinessPrioritiesState'

export const selectBusinessPrioritiesUserInfo = createSelector(
  [selectBusinessPrioritiesState],
  (state) => state.userInfo
)
